<div class="side-modal modal-el" (click)="backdropClick($event)">
  <mat-icon
    class="close-side-modal"
    (click)="closeModal()"
    data-test-id="edit-user-close"
    >close</mat-icon
  >
  <div
    class="side-info modal-info-box-alt"
    #editModal
    data-test-id="edit-user-modal"
  >
    <div class="side-info-head">
      <div class="title-close">
        <span>User Details</span>
      </div>
      <div class="main-info">
        <div class="upper">{{ user.firstName }} {{ user.lastName }}</div>
        <div class="middle">{{ user.companyName }}</div>
        <div class="lower">
          Last activity
          {{
            userLastActivity
              ? (userLastActivity | date : "MM/dd/yyyy hh:mm a")
              : "N/A"
          }}
        </div>
      </div>
    </div>
    <div class="edit-form">
      <form [formGroup]="userForm">
        <div class="double-controls">
          <div class="form-control">
            <label for="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              formControlName="firstName"
              data-test-id="edit-user-first-name"
            />
            <div class="field-error">
              <span
                *ngIf="
                  userForm.controls.firstName?.touched &&
                  userForm.controls.firstName?.hasError('required')
                "
                >First name is required</span
              >
              <span
                *ngIf="
                  userForm.controls.firstName?.touched &&
                  userForm.controls.firstName?.hasError('pattern')
                "
                >Incorrect name</span
              >
            </div>
          </div>
          <div class="form-control">
            <label for="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              formControlName="lastName"
              data-test-id="edit-user-last-name"
            />
            <div class="field-error">
              <span
                *ngIf="
                  userForm.controls.lastName?.touched &&
                  userForm.controls.lastName?.hasError('required')
                "
                >Last name is required</span
              >
              <span
                *ngIf="
                  userForm.controls.lastName?.touched &&
                  userForm.controls.lastName?.hasError('pattern')
                "
                >Incorrect last name</span
              >
            </div>
          </div>
        </div>
        <div class="form-control phone-control">
          <label for="phoneNumber">Phone Number</label>
          <input
            type="text"
            id="phoneNumber"
            (input)="validateTel()"
            formControlName="phoneNumber"
            data-test-id="edit-user-phone"
          />
        </div>
        <div class="field-error">
          <span *ngIf="isTelCustomError">{{ telError }}</span>
        </div>
        <div class="form-control email-control">
          <label for="email">Email</label>
          <input
            type="text"
            id="email"
            readonly
            formControlName="email"
            data-test-id="edit-user-email"
          />
        </div>
        <div class="field-error">
          <span
            *ngIf="
              userForm.controls.email?.touched &&
              userForm.controls.email?.hasError('required')
            "
            >Last name is required</span
          >
          <span
            *ngIf="
              userForm.controls.email?.touched &&
              userForm.controls.email?.hasError('pattern')
            "
            >Incorrect email</span
          >
        </div>
        <div class="form-control role-control">
          <label>Role</label>
          <mat-form-field appearance="outline">
            <mat-select
              [(value)]="selectedRole"
              disableRipple
              hideSingleSelectionIndicator
              (selectionChange)="changeRole()"
              data-test-id="edit-user-role"
            >
              <mat-option
                *ngFor="let role of availableRoles"
                [value]="role"
                [attr.data-test-id]="'edit-user-role-option-' + role.id"
                >{{ role.name }}</mat-option
              >
            </mat-select>
            <mat-icon matSuffix class="select-icon-replacement"
              >expand_more</mat-icon
            >
          </mat-form-field>
        </div>

        <!--
          ECDEV-256: a user may belong to several companies and switch between them at runtime.
          Hidden for CM staff, who have no company at all.
        -->
        <div class="form-control company-control" *ngIf="canEditCompanies">
          <label>Companies</label>
          <mat-form-field appearance="outline">
            <mat-select
              multiple
              disableRipple
              [(value)]="selectedCompanyIds"
              (selectionChange)="changeCompanies()"
              data-test-id="edit-user-companies"
            >
              <mat-option
                *ngFor="let company of selectableCompanies"
                [value]="company.id"
                [attr.data-test-id]="'edit-user-company-option-' + company.id"
                >{{ company.name }}</mat-option
              >
            </mat-select>
            <mat-icon matSuffix class="select-icon-replacement"
              >expand_more</mat-icon
            >
          </mat-form-field>
          <span class="company-hint">
            A user's companies must all be of the same type — several Customers,
            or several Cold Storages, never a mix.
          </span>
        </div>

        <div
          class="form-control company-control"
          *ngIf="canEditCompanies && selectedCompanyIds.length > 1"
        >
          <label>Default company at login</label>
          <mat-form-field appearance="outline">
            <mat-select
              disableRipple
              hideSingleSelectionIndicator
              [(value)]="defaultCompanyId"
              (selectionChange)="changeCompanies()"
              data-test-id="edit-user-default-company"
            >
              <mat-option
                *ngFor="let company of selectedCompanies"
                [value]="company.id"
                >{{ company.name }}</mat-option
              >
            </mat-select>
            <mat-icon matSuffix class="select-icon-replacement"
              >expand_more</mat-icon
            >
          </mat-form-field>
        </div>

        <div class="form-control">
          <mat-checkbox
            formControlName="receiveEmailNotificationWhenOrderDetailsChanged"
            data-test-id="edit-user-notify-details"
            >Notify user of details changes</mat-checkbox
          >
          <mat-checkbox
            formControlName="receiveEmailNotificationWhenOrderStageChanged"
            data-test-id="edit-user-notify-stage"
            >Notify user of stage changes</mat-checkbox
          >
          <mat-checkbox
            formControlName="receiveEmailNotificationWhenOrderFileUploaded"
            data-test-id="edit-user-notify-file"
            >Notify user of file upload</mat-checkbox
          >
        </div>
      </form>
    </div>
    <div
      class="reset-pass"
      (click)="forgotPassword()"
      data-test-id="edit-user-reset-password"
    >
      Reset Password
    </div>
    <div class="acc-del">
      <div class="del-header">Account deletion</div>
      <div class="del-help">
        You will be asked to confirm the account deletion. After the process
        will be finished an employee couldn’t use his personal credentials to
        log in.
      </div>
      <div
        class="del-acc-btn"
        (click)="deleteAccount()"
        data-test-id="edit-user-delete-account"
      >
        Delete Account
      </div>
    </div>
    <div class="side-actions form-actions">
      <button
        mat-stroked-button
        class="cancel-btn"
        (click)="closeModal()"
        data-test-id="edit-user-cancel"
      >
        Cancel
      </button>
      <button
        mat-button
        class="action-btn"
        [disabled]="userForm.invalid || isTelCustomError"
        (click)="editUser()"
        *ngIf="!isRoleChanged && !areCompaniesChanged"
        data-test-id="edit-user-save"
      >
        Save
      </button>
      <button
        mat-button
        class="action-btn"
        [disabled]="!isCompanySelectionValid"
        (click)="editUserRole()"
        *ngIf="isRoleChanged || areCompaniesChanged"
        data-test-id="edit-user-update-role"
      >
        {{ areCompaniesChanged ? 'Update Access' : 'Update Role' }}
      </button>
    </div>
  </div>
</div>
